import React from 'react'
import PropTypes from 'prop-types'
import theme from 'styles/theme'
import { Eyebrow, Body14 } from 'components/Typography'
import FormLabel from '../FormLabel'
import FormErrorMessage from '../FormErrorMessage'
import FormRadioItem from './FormRadioGroup.style'

const FormRadioGroup = ({
  label,
  name,
  value,
  options,
  required,
  hasError,
  errorMessage,
  isDisabled,
  handleChange,
}) => {
  return (
    <>
      {label && (
        <FormLabel hasError={hasError} isDisabled={isDisabled}>
          <Eyebrow color={theme.colors.sagedark}>{label}</Eyebrow>
        </FormLabel>
      )}

      {options &&
        options.map((option, index) => {
          const key = `option_${index}`
          return (
            option.available !== false && (
              <FormRadioItem key={key} hasError={hasError}>
                <FormLabel hasError={hasError} isDisabled={isDisabled}>
                  <input
                    type="radio"
                    name={name}
                    value={option.value}
                    onChange={handleChange}
                    checked={value === option.value}
                    disabled={isDisabled}
                    required={required}
                  />
                  <Body14 color={theme.colors.sagedark}>{option.name}</Body14>
                </FormLabel>
              </FormRadioItem>
            )
          )
        })}

      {hasError && <FormErrorMessage errorMessage={errorMessage} />}
    </>
  )
}

FormRadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  required: PropTypes.bool,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  isDisabled: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
}

FormRadioGroup.defaultProps = {
  value: '',
  required: false,
  hasError: false,
  errorMessage: '',
  isDisabled: false,
}

export default FormRadioGroup
